import { commonPricingIntegrationErrorsManagement } from "../../utils";

/**
 * Handle errors of pricing integration in RA Filing
 */
export const raFillingPricingErrorsManagement = (error: any): string => {
    let mess = '';
    if (error.response?.status === 400) {
        switch (error.response?.data?.errorDetails) {
            case "\"ERROR_ON_TAX_CONFIGURATION\"":
                mess = 'customerData.message.error.taxConfig';
                break;
            case "\"ERROR_PRC_EXPECTATION_FAILED\"":
                mess = 'customerData.message.error.pcrExpectationFailed';
                break;
            case "\"UPSELL_NOT_PERMITTED\"":
                mess = 'customerData.message.error.upsellNotPermitted';
                break;
            case "\"ERROR_VEHICLE_NOT_INFLATED\"":
                mess = 'common.error.vehicleNotInflated';
                break;
            case "\"ERROR_UPSELL_OR_DOWNGRADE_NOT_COMPATIBLE\"":
                mess = 'common.error.upsellOrDowngradeNotCompatible';
                break;
            case "\"ERROR_MISSING_EXCESSESS\"":
                mess = 'common.error.missingExcesses';
                break;
            case "\"ERROR_PRICING_MISSING_CONFIGURATION\"":
                mess = 'common.error.pricingMissingConfiguration';
                break;
            case "\"ERROR_CARBOX_MISSING_LAST_BKN\"":
                mess = 'common.error.bknMissingLastBkn';
                break;
            case "\"ERROR_CARBOX_EMPTY_BKN_LIST\"":
                mess = 'common.error.bknEmptyCarboxBknList';
                break;
            case "\"ERROR_RA_NOT_FOUND\"":
                mess = 'common.error.raNotFound';
                break;
            case "\"ERROR_TOLL_ANCILLARY\"":
                mess = 'common.error.etollAncillaryError';
                break;
            default:
                mess = 'customerData.message.error.tryLater';
                break;
        }
    }

    if(!mess)
        mess = commonPricingIntegrationErrorsManagement(error) || 'customerData.message.error.tryLater';

    return mess;
};